/**
 * Extract first name, last name, and display name from Supabase user metadata.
 * Handles all OAuth providers:
 *   - Email signup: first_name, last_name, display_name
 *   - Google OAuth: given_name, family_name, full_name/name
 *   - Apple OAuth: full_name/name (split into first/last)
 */
export function extractUserNames(user) {
  const meta = user?.user_metadata || {}

  // 1. Try explicit first/last fields (email signup, then Google)
  let firstName = meta.first_name || meta.given_name || null
  let lastName = meta.last_name || meta.family_name || null

  // 2. If still missing, parse from full_name or name (Apple OAuth / fallback)
  if (!firstName && !lastName) {
    const fullName = meta.full_name || meta.name || ''
    if (fullName) {
      const parts = fullName.trim().split(/\s+/)
      firstName = parts[0] || null
      lastName = parts.length > 1 ? parts.slice(1).join(' ') : null
    }
  }

  // 3. Build display name
  const displayName =
    meta.display_name ||
    meta.full_name ||
    meta.name ||
    [firstName, lastName].filter(Boolean).join(' ') ||
    user?.email?.split('@')[0] ||
    'Player'

  return { firstName, lastName, displayName }
}
